<template>
  <div style="">
    <vue-tabs>
      <v-tab :title="$t('AllUsers')">
        <div slot="Title" style="position: relative; height: 100%; min-height: 100%" class="editor-main">
          {{ $t('AllUsers') }}
        </div>
        <div id="2" class="tab-inner">
          <UserList :users="userCollection" @SearchNeeeded="LoadUsers" @SelectionChanged="AssignUsers"></UserList>
        </div>
      </v-tab>
      <v-tab :title="SelectedTitle()">
        <div slot="Title" style="position: relative; height: 100%; min-height: 100%" class="editor-main">
          {{ $t('AssignedUsers') }}
        </div>
        <div id="2" class="tab-inner">
          <span>
            <UserList :users="selectedUsers">

            </UserList>
          </span>
        </div>
      </v-tab>
    </vue-tabs>
    <div class="vx-row command-buttons">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vs-button id="share-button" class="vs-con-loading__container" @click="AssignOnboarding">{{ $t('Assign') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import vSelect from 'vue-select'
  import UserList from "@/views/components/extra-components/users/UserList.vue";
  import { VueTabs, VTab } from "vue-nav-tabs";

  export default {
    data() {
      return {
        email: "",
        ShareTypeObject: null,
        userCollection: [],
        selectedUsers: []
      }

    },
    props: ["shareObjectType", "shareObjectId"],
    mounted() {
      this.LoadUsers();
    },
    methods: {
      AssignOnboarding() {
        var instance = this;
        instance.$vs.loading({
          container: '#share-button',
          scale: 0.6
        })

        TCVelikClient.PostRelative("/api/share/AssignUsersToItem",
          {
            itemId: instance.shareObjectId,
            emails: instance.selectedUsers.map(u => u.email),
            shareObjectType: instance.shareObjectType
          })
          .then(function (response) {
            if (response) {
              instance.$vs.notify({
                title: instance.$t('SuccessfullyAssignedItem'),
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
              instance.$vs.loading.close("#share-button > .con-vs-loading")
            }
          }).catch(err => {
            if (err.response.status == 400) {
              instance.$vs.notify({
                title: instance.$t('NoSuchUserExists'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
            else {
              instance.$vs.notify({
                title: instance.$t('ProblemSharingOnboarding'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
            instance.$vs.loading.close("#share-button > .con-vs-loading")

          });
      },
      AssignUsers(selection) {
        this.selectedUsers = selection;
      },
      LoadUsers(skip, take, search) {
        var instance = this;
        const query = `
            query Users($skip: Int, $take: Int, $search: String) {
               users(skip: $skip, take: $take, search: $search) {
                 result{
                   avatarUrl
                   firstName
                   lastName
                   id
                   userName
                   email
                   phoneNumber
                   phoneNumberConfirmed
                   apiKey
                     roles {
                         id
                         name
                         normalizedName
                         concurrencyStamp
                     }
                   }
               }
           }
           `;

        const req = {
          query,
          variables: {
            skip: skip,
            take: take,
            search: search
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$set(instance, "userCollection", response.data.data.users.result);
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingUsers'));
          }
        });

      },
      SelectedTitle() {
        if (this.selectedUsers) {
          return this.$t('SelectedUsers') + " " + this.selectedUsers.length;
        }
        return this.$t('ZeroSelected');
      },
      GetSelected() {
        if (this.selectedUsers && this.selectedUsers.length > 0)
          return this.selectedUsers;
        return [];
      },
      LoadAssignedUsers(skip, take, search) {
        var instance = this;
        const query = `
            query SpacePermissions($skip: Int, $take: Int, $search: String) {
               spacePermissions(skip: $skip, take: $take, search: $search) {
                 result{
                   user{
                     apiKey
                      roles {
                          id
                          name
                          normalizedName
                          concurrencyStamp
                      }
                    }
                   }
               }
           }
           `;

        const req = {
          query,
          variables: {
            skip: skip,
            take: take,
            search: search
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$set(instance, "userCollection", response.data.data.users.result);
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingUsers'));
          }
        });
      }
    },
    components: {
      vSelect,
      UserList,
      VueTabs,
      VTab
    }
  }
</script>

<style scoped>

  * >>> .command-buttons {
    position: absolute;
    bottom: 10px;
    right: 60px;
  }

  * >>> .nav-tabs {
    padding: 5px;
  }

    * >>> .nav-tabs .tab {
      float: left;
      margin-right: 10px;
      padding: 5px 10px 5px 10px;
    }

      * >>> .nav-tabs .tab.active {
        background: white;
        border-bottom: 1px solid var(--primary);
      }

  * >>> .tab-container {
    height: 400px;
  }

  * >>> .tab-content {
    margin-top: 30px;
  }

  * >>> .tree-wrapper {
    overflow: scroll;
    height: calc(100vh);
  }

  * >>> .tab-inner {
    padding-left: 9px;
    background: white;
    min-height: 80%;
    margin-left: 5px;
    padding-top: 10px;
  }
</style>

